import {
    FGCheckbox,
    FGIcons,
    FGTile,
    FGTooltip,
    FGTypography,
    TOOLTIP_PLACEMENT,
} from '@fg/design-system';
import React from 'react';
import { RiskPickerItem } from './RiskPicker';
import cx from 'classnames';

type RiskStructure = 'tree' | 'list';

type Props = {
    item: RiskPickerItem;
    isMultiSelect?: boolean;
    isSelected?: boolean;
    onClick: (id: number) => void;
    riskStructure: RiskStructure;
};
const RiskPickerListItem = React.memo((props: Props) => {
    const { item, isMultiSelect, isSelected, onClick, riskStructure } = props;
    return (
        <FGTile
            data-testid="risk-option"
            appearance="primary"
            padding="none"
            className={cx('new-risk-picker-list-item', {
                tree: riskStructure === 'tree',
                list: riskStructure === 'list',
                selected: isSelected,
            })}
            onClick={e => {
                e.stopPropagation();
                if (item.disabled) {
                    return;
                }
                onClick(item.id);
            }}>
            <FGTooltip
                offset={[0, riskStructure === 'tree' ? 16 : 8]}
                placement={TOOLTIP_PLACEMENT.right}
                className="new-risk-picker-list-item-tooltip"
                content={
                    <div style={{ maxWidth: 244 }}>
                        <FGTypography
                            variant="body4"
                            tag="label"
                            cssStyle={{ width: '100%' }}>
                            {item.definition || item.name}
                        </FGTypography>
                    </div>
                }>
                <div
                    style={{
                        width: '100%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                        padding: 8,
                        gap: 0,
                    }}>
                    <div style={{ flex: 1 }}>
                        <FGTypography
                            cssStyle={{
                                flex: 1,
                                display: 'flex',
                                cursor: 'pointer',
                            }}
                            tag="label"
                            variant="body3-short"
                            color={item.disabled ? 'weak' : 'strong'}>
                            {item.name}
                        </FGTypography>
                    </div>
                    {!isMultiSelect && isSelected && <FGIcons icon="Check2" />}
                    {isMultiSelect && (
                        <div style={{ display: 'flex', pointerEvents: 'none' }}>
                            <FGCheckbox
                                isChecked={isSelected}
                                disabled={item.disabled}
                            />
                        </div>
                    )}
                </div>
            </FGTooltip>
        </FGTile>
    );
});

export default RiskPickerListItem;
